import PropTypes from 'prop-types';

function MMOurBrandsInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_1721_47781)">
                <path
                    d="M13.3337 1.05336L3.81658 9.74974C3.27045 10.2488 3.23228 11.096 3.73131 11.6422L16.0827 25.1591C16.5817 25.7053 17.429 25.7435 17.9751 25.2444L27.4922 16.548C28.0383 16.049 28.0765 15.2017 27.5774 14.6556L15.2261 1.13863C14.7271 0.592501 13.8798 0.554323 13.3337 1.05336Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22.2635 1.36472L10.1437 5.75922C9.44823 6.01139 9.08886 6.77962 9.34103 7.47511L15.5825 24.6887C15.8346 25.3842 16.6029 25.7436 17.2984 25.4914L29.4182 21.0969C30.1137 20.8447 30.4731 20.0765 30.2209 19.381L23.9794 2.16741C23.7273 1.47192 22.959 1.11255 22.2635 1.36472Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M31.1598 5.32027L18.2968 4.4569C17.5586 4.40735 16.9201 4.96556 16.8706 5.70369L15.6443 23.9728C15.5948 24.7109 16.153 25.3495 16.8911 25.399L29.7541 26.2624C30.4922 26.3119 31.1308 25.7537 31.1803 25.0156L32.4066 6.74649C32.4561 6.00836 31.8979 5.36982 31.1598 5.32027Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23.9876 13.2184C23.7147 12.8605 23.3675 12.1376 22.3079 12.2332C21.2519 12.3254 20.3022 13.2751 20.3695 14.4658C20.4368 15.66 21.0889 16.7266 21.9535 17.5311C22.8182 18.3355 23.456 18.7146 23.7466 18.8032C24.0478 18.7288 25.7205 17.9138 26.4575 16.9995C27.1982 16.0817 27.9494 15.3517 27.4994 13.7216C27.0493 12.0915 25.1109 12.414 24.87 12.6266C24.629 12.8392 23.9876 13.2149 23.9876 13.2149V13.2184Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1721_47781">
                    <rect width="35.4794" height="29.5224" fill="white" transform="translate(0.783508 0.351562)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMOurBrandsInactive;

MMOurBrandsInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MMOurBrandsInactive.defaultProps = {
    className: null,
    width: 28,
};
